import React from 'react';
import { Button, Tooltip } from '@mui/material';
import { FilterAltOff } from '@mui/icons-material';
import { pageFilterActionButtonSx } from '../utils/pageFilterStyles';

const ClearAllFiltersButton = ({ onClear, disabled = false, sx = {} }) => (
  <Tooltip title={disabled ? 'No filters applied' : 'Reset all filters to default'}>
    <span>
      <Button
        variant="outlined"
        size="small"
        startIcon={<FilterAltOff />}
        onClick={onClear}
        disabled={disabled}
        sx={{
          ...pageFilterActionButtonSx,
          ...sx,
        }}
      >
        Clear All Filters
      </Button>
    </span>
  </Tooltip>
);

export default ClearAllFiltersButton;
